import React, { Fragment } from 'react';
import WidgetV1 from 'app/BargainWidget/Bargains/WidgetV1/WidgetV1';

const Bargains = () => {
  return (
    <Fragment>
      <WidgetV1 />
    </Fragment>
  );
};

export default Bargains;
